export function useFetchMenus(query: SearchParameters = {}) {
  return useJsonApiFetch<Menu[]>('/api/v1/cms/menus')
}

export function fetchMenus() {
  return $api<Menu[]>('/api/v1/cms/menus', { deserialize: true })
}
